export const SET_SETTING = 'SETTING/SET_SETTING'
export const SET_STATUSLIST = 'SETTING/SET_STATUSLIST'
export const SET_REFSTATUSLIST = 'SETTING/SET_REFSTATUSLIST'
export const SET_STATUSSELECT = 'SETTING/SET_STATUSSELECT'
export const SET_ATTACHMENTTYPE = 'SETTING/SET_ATTACHMENTTYPE'
